module.exports = __webpack_public_path__ + "img/all_games.7c685ade.svg";